import React from 'react';
import { RootState, store } from 'src/app/store';
import {
  selectUserInfoFromHeader,
  updateHasSalesAssistantLoaded,
  UserInfo,
} from '../../store/slice';
import { connect } from 'react-redux';
import { canShowSalesAssistant, createMountProps } from './salesAssistantUtils';
import Mount from '../CommunicationsDrawer/Mount';
import Remote from '../CommunicationsDrawer/Remote';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';

const loader = () =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  import('salesAssistant/ChatBotComponent');

interface SalesAssistantModuleProps {
  userInfo: UserInfo;
}

const SalesAssistantModule = (props: SalesAssistantModuleProps) => {
  const userEmail = props.userInfo?.customerInfo?.primaryEmail || '';
  const userName = props.userInfo?.customerInfo?.fullName || '';

  if (!canShowSalesAssistant(userEmail)) return null;

  const amazonAlias = userEmail.split('@')[0];
  const chromeConfigContext = useInternalChromeConfigContext();
  const remoteProps = {
    loader,
    timeout: 10000,
    afterLoad: () => {
      store.dispatch(updateHasSalesAssistantLoaded(true));
    },
    render: (loaded) => {
      if (!loaded) return null;
      const { mount } = loaded;

      return (
        <Mount
          containerId="sales-assistant-drawer"
          mount={mount}
          mountProps={createMountProps(
            amazonAlias,
            userName,
            chromeConfigContext,
          )}
        />
      );
    },
  };

  return <Remote {...remoteProps} />;
};

const mapStateToProps = (state: RootState) => {
  return {
    userInfo: selectUserInfoFromHeader(state),
  };
};

export default connect(mapStateToProps)(SalesAssistantModule);
